<script>
  export default {
    data() {
      return {
        is_online: true
      }
    },

    created() {
      window.addEventListener('offline', this.onNetworkChange.bind(this), false)
      window.addEventListener('online', this.onNetworkChange.bind(this), false)

      this.onNetworkChange()
    },

    methods: {
      onNetworkChange() {
        if (process.env.NODE_ENV !== 'production') {
          return
        }

        this.is_online = navigator.onLine
      }
    }
  }
</script>

<template>
  <div class="Offline" v-if="!is_online">
    <div class="has-text-centered content">
      <h1>DEAD BALL - Connexion interrompue</h1>
      <p><i class="material-icons">signal_cellular_connected_no_internet_4_bar</i></p>
      <p>Il semblerait que tu n'ait plus internet, le jeu est en pause pour toi !</p>
      <p>Relance ta connexion et clique ci-dessous pour relancer le site</p>
      <p><a href="/" class="button is-danger">RESTART THE GAME</a></p>
    </div>
  </div>
</template>

<style lang="scss">
  .Offline {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: pxToEm(40);
    background: $grey-lightest;

    i {
      padding: pxToEm(20);
      font-size: 72px;
    }
  }
</style>



// WEBPACK FOOTER //
// AppOffline.vue?d74a184c